
const containerLayoutEnum = {
    BOOK : 0,
    POLAROID : 1,
    ROUNDED_PHOTO : 2,
}

export default containerLayoutEnum;